import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getInitialTheme, setTheme } from './theme';
import './ThemeToggle.css';

// Selectable themes, presented as a dropdown inside the Settings popup. The
// active theme has already been applied to <html> by the inline script in
// public/index.html; here we only read the current value and switch it. The
// `labelKey` is resolved against the translation bundle at render time.
const OPTIONS = [
  { value: 'light', icon: '☀️', labelKey: 'theme.light' },
  { value: 'dark', icon: '🌙', labelKey: 'theme.dark' },
  { value: 'nature', icon: '🌿', labelKey: 'theme.nature' },
  { value: 'nature-dark', icon: '🌑', labelKey: 'theme.natureDark' },
];

function ThemeToggle() {
  const { t } = useTranslation();
  const [theme, setThemeState] = useState(getInitialTheme);

  const handleChange = (event) => {
    const value = event.target.value;
    setTheme(value);
    setThemeState(value);
  };

  return (
    <select
      className="theme-select"
      value={theme}
      onChange={handleChange}
      aria-label={t('theme.label')}
    >
      {OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.icon} {t(option.labelKey)}
        </option>
      ))}
    </select>
  );
}

export default ThemeToggle;
